export default __webpack_public_path__ + "static/media/cocard_member_office_logo.274b19b6.png";